import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { notification, Image } from "antd";
import { VendorModel } from "../models/Vendor";
import { openNotificationWithIcon } from "../helperFunctions";
import backarrow from "../assets/images/icon/back-arrow.svg";
import {
  Form,
  Spin,
} from "antd";
import { useSelector } from "react-redux";
import "./index.css";
import CustomerLandingPage from "./CustomerLandingPage";
import CustomerDetails from "./CustomerDetails";
import { useLoaderData } from "react-router-dom"

export default function CustomerPage() {
  const { vendor_name } = useParams();
  const customer_search_box_label = useSelector(
    (state) => state.customer_search_box_label
  );
  const customer_search_box_note = useSelector(
    (state) => state.customer_search_box_note
  );

  const search_box_placeholder_label = useSelector(
    (state) => state.search_box_placeholder_label
  );

  const screenWidth = window.innerWidth;

  const [customerData, setCustomerData] = useState({});
  const [loader, setLoader] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [minimum_accept_amount_for_payment, setAmountForPayment] = useState(0)
  const [customerID, setCustomerID] = useState("")


  const [customerForm] = Form.useForm();
  const [payBillForm] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  const data = useLoaderData()


  const callCustomerDetailsAPI = async (values) => {
    setLoader(true);
    try {
      const response = await VendorModel.getCustomerDetails({
        customer_id: values?.customer_id,
        shortname: vendor_name,
      });
      if (response.success) {
        setLoader(false);
        setCustomerData(response?.data?.data);
        setAmountForPayment(response?.data?.data?.minimum_amount_payable)
        setCustomerID(response?.data?.data?.customer_id)
        setShowDetails(true);
        openNotificationWithIcon(
          api,
          "success",
          "Success",
          "Customer Details Fetched successfully."
        );
      } else {
        setLoader(false);
        openNotificationWithIcon(
          api,
          "error",
          "Error",
          response?.error || "Something went wrong. Try again."
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const callPayBillAPI = async (values) => {
    setLoader(true);
    try {
      const customer_id = customerID
      const response = await VendorModel.payBill({
        customer_id: customer_id,
        shortname: vendor_name,
        amount: values?.amount,
      });
      if (response.success) {
        payBillForm.resetFields();
        window.location.href = response?.data?.url;
        setLoader(false);
      } else {
        openNotificationWithIcon(
          api,
          "error",
          "Error",
          response?.error || "Something went wrong. Try again."
        );
        setLoader(false);
      }
    } catch (error) {
      console.error("Error in fetching data:", error);
    }
  };

  const backButtonClick = () =>{
    setShowDetails(false)
    customerForm.resetFields();
    payBillForm.resetFields();
  }
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 769);
    };
    window.addEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div >
        {loader && (
          <div className="spinner-container">
            <Spin
              className="spinner"
              size="large"
            />
          </div>
        )}
        {contextHolder}
        <div>
          {isMobile && showDetails ? <div style={{ padding: "5px 0", background:"#F9F9F9" }}>
            <span
              className="back-btn"
              onClick={() => backButtonClick()}
            >
              <Image style={{ padding: "5px" }} src={backarrow} alt="" preview={false} />
              Back
            </span>
          </div> : null}

          {!loader && !showDetails && (
            <CustomerLandingPage
              customerForm={customerForm}
              callCustomerDetailsAPI={callCustomerDetailsAPI}
              customer_search_box_label={customer_search_box_label}
              customer_search_box_note={customer_search_box_note}
              search_box_placeholder_label = {search_box_placeholder_label}
            />
             )}
          {!loader && showDetails && (
              <CustomerDetails
                isMobile={isMobile}
                backButtonClick={backButtonClick}
                customerData={customerData}
                payBillForm={payBillForm}
                callPayBillAPI={callPayBillAPI}
                screenWidth={screenWidth}
                minimum_accept_amount_for_payment={minimum_accept_amount_for_payment}
              />
            )}
        </div>
      </div>
    </>
  );
}

export const callVendorAPI = async ({params}) => {
    const queryString = window.location.pathname;
    let response = {
      success : false,
      data : null
    }
    if(queryString){
      response = await VendorModel.checkVendor({ "shortname": params.vendor_name });
    }
    return response
};